<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="title" :label="$t('内容类型')">
<!--        <span slot="label">
          <a-tooltip>
            内容类型<template slot="title">内容类型</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('请输入')+$t('内容类型')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['title']"
            :disabled="!form.title"
            input-type="input"
            table-name="discover_report_type"
            table-field="title"
            :field-value="form.title"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="reportType" :label="$t('举报类型')">
<!--        <span slot="label">
          <a-tooltip>
            举报类型<template slot="title">举报类型</template>
          </a-tooltip>
        </span>-->
        <a-select v-model="form.reportType" :placeholder="$t('请选择')" allow-clear>
          <a-select-option v-for="item in reportTypeList" :key="item.type" :value="item.type">{{ $t(item.name) }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="sort" :label="$t('排序')">
<!--        <span slot="label">
          <a-tooltip>
            排序<template slot="title">排序</template>
          </a-tooltip>
        </span>-->
        <a-input-number style="width: 100%;" v-model="form.sort" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="status" :label="$t('状态')">
<!--        <span slot="label">
          <a-tooltip>
            状态<template slot="title">状态</template>
          </a-tooltip>
        </span>-->
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.StatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryReportType, addDiscoveryReportType, updateDiscoveryReportType } from '@/api/discovery/discoveryReportType'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        title: null,

        reportType: null,

        sort: null,
        localeFieldMap: {},
        status: 0

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '内容类型' + this.$t('不能为空'), trigger: 'blur' }
        ],
        reportType: [
          { required: true, message: '举报类型' + this.$t('不能为空'), trigger: 'change' }
        ],
        sort: [
          { required: true, message: '排序' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态' + this.$t('不能为空'), trigger: 'blur' }
        ]
      },
      reportTypeList: [{ type: 'user', name: '举报用户' }, { type: 'article', name: '举报文章' }, { type: 'comment', name: '举报评论' }]
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        reportType: 'post',
        sort: 1,
        localeFieldMap: {},
        status: 1
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryReportType({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryReportType(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryReportType(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
